import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Truck } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const DriverProductivity = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/delivery-orders/reports/driver-productivity`)
      .then((res) => setData(res.data))
      .catch(() => {});
  }, []);

  if (!data || data.drivers.length === 0) return null;

  return (
    <Card className="mb-6" data-testid="driver-productivity-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <Truck size={18} className="text-[#5c1a1a]" />
          Jobs Completed per Driver — Last 8 Weeks
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-gray-500 border-b">
              <th className="text-left py-2 pr-2 font-medium">Driver</th>
              {data.weeks.map((w, i) => (
                <th key={w.start} className={`text-center py-2 px-1 font-medium whitespace-nowrap ${i === data.weeks.length - 1 ? 'text-[#5c1a1a] font-bold' : ''}`}>
                  {i === data.weeks.length - 1 ? 'This Week' : w.label}
                </th>
              ))}
              <th className="text-center py-2 pl-2 font-bold">Total</th>
            </tr>
          </thead>
          <tbody>
            {data.drivers.map((d) => (
              <tr key={d.driver_name} className="border-b last:border-b-0" data-testid={`driver-row-${d.driver_name.replace(/\s+/g, '-')}`}>
                <td className="py-2 pr-2 font-semibold text-gray-900 whitespace-nowrap">{d.driver_name}</td>
                {d.weekly.map((c, i) => (
                  <td key={i} className={`text-center py-2 px-1 ${i === d.weekly.length - 1 ? 'font-bold text-[#5c1a1a] bg-amber-50 rounded' : c === 0 ? 'text-gray-300' : 'text-gray-700'}`}>
                    {c}
                  </td>
                ))}
                <td className="text-center py-2 pl-2 font-bold">{d.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};
